import { ButtonLink } from "../components/button-link";
import { SiteHeader } from "../components/site-header";

const fileContents = [
  "What exists and where it is",
  "Who your family should call first",
  "What they should—and should not—do",
  "What you currently intend",
];

export function PublicHome() {
  return (
    <div className="page-frame">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <SiteHeader />
      <main id="main-content">
        <section className="hero shell">
          <div className="hero__copy">
            <p className="eyebrow eyebrow--light">A private Start Here File</p>
            <h1>Leave clarity, not a scavenger hunt.</h1>
            <p className="hero__lede">
              Create one calm, living guide so the people you love know what exists, who to call,
              what not to do, and what you intended—without storing passwords or secrets.
            </p>
            <div className="hero__actions">
              <ButtonLink to="/auth/start">Create your file</ButtonLink>
              <a className="text-link text-link--light" href="#how-it-helps">
                See what it covers
              </a>
            </div>
            <p className="hero__note">
              Private by default · Passkey-first · You confirm every change
            </p>
          </div>
          <aside className="preview-card" aria-label="Example Start Here File outline">
            <div className="preview-card__topline">
              <span>Start Here</span>
              <span className="status-pill">Private</span>
            </div>
            <p className="preview-card__name">Your family’s first clear page</p>
            <ul>
              {fileContents.map((item, index) => (
                <li key={item}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  {item}
                </li>
              ))}
            </ul>
            <p className="preview-card__footer">No passwords. No automatic release.</p>
          </aside>
        </section>

        <section
          id="how-it-helps"
          className="promise-section shell"
          aria-labelledby="promise-title"
        >
          <div>
            <p className="eyebrow">Built around the questions families actually face</p>
            <h2 id="promise-title">A map people can use when thinking is hard.</h2>
          </div>
          <div className="principle-grid">
            <article>
              <span className="principle-number">01</span>
              <h3>Speak naturally</h3>
              <p>
                Describe what matters in your own words. The assistant proposes a clean structure.
              </p>
            </article>
            <article>
              <span className="principle-number">02</span>
              <h3>Stay in control</h3>
              <p>Nothing becomes part of your file until you inspect and confirm it.</p>
            </article>
            <article>
              <span className="principle-number">03</span>
              <h3>Share precisely</h3>
              <p>Choose exactly who may see each kind of information. Roles never imply access.</p>
            </article>
          </div>
        </section>
      </main>
      <footer className="site-footer">
        <div className="shell site-footer__inner">
          <span>Bye Now</span>
          <span>A thoughtful beginning for difficult moments.</span>
        </div>
      </footer>
    </div>
  );
}
